import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input,
} from '@angular/core';
import { Upsell } from '@core/models';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

/**
 * Presentational "upsell toggle card" (image + title + "+$X Per Ticket" + toggle +
 * selected-state border), used in the checkout "Need more Fun?" upsell grid.
 *
 * Purely a restyle of the existing upsell data already exposed by `group-outing`/
 * `UpgradesService` — no new data or business logic. GS-local for now; it's a
 * candidate for future promotion to the shared SDC library since it has no
 * cart-specific dependency.
 */
@Component({
  selector: 'app-upsell-toggle-card',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, TooltipModule],
  templateUrl: './upsell-toggle-card.component.html',
  styleUrl: './upsell-toggle-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellToggleCardComponent {
  upsell = input.required<Upsell>();
  checked = input<boolean>(false);
  // True while this upsell's buyer type isn't editable in ProVenue and a
  // discount code is active — the card can't be toggled and the parent passes
  // `disabledTooltip` to explain why. The info-button tooltip is suppressed
  // while disabled so the disabled reason is the only tooltip shown.
  disabled = input<boolean>(false);
  disabledTooltip = input<string>('');

  @Output() toggle = new EventEmitter<HTMLInputElement>();

  onToggle(radio: HTMLInputElement) {
    if (this.disabled()) {
      return;
    }
    this.toggle.emit(radio);
  }
}
